export const ADD_ANSWER = "ADD_ANSWER";
export const SET_ANSWERS = "SET_ANSWERS";
export const CLEAR_ANSWERS = "CLEAR_ANSWERS";
export const SET_STATUS = "SET_STATUS";
export const SET_SUBMITTED = "SET_SUBMITTED";
